export default [
  {
    path: '/notice',
    name: 'notice',
    component: () => import('@/views/notice/index.vue'),
    meta: {
      title: '新闻中心',
    },
  },
  {
    path: '/notice/wzgg',
    name: 'notice-wzgg',
    component: () => import('@/views/notice/wzgg.vue'),
    meta: {
      title: '网站公告',
      hiddenCarousel: true,
    },
  },
  {
    path: '/notice/gydt',
    name: 'notice-gydt',
    component: () => import('@/views/notice/gydt.vue'),
    meta: {
      title: '公益动态',
      hiddenCarousel: true,
    },
  },
  {
    path: '/notice/spdt',
    name: 'notice-spdt',
    component: () => import('@/views/notice/spdt.vue'),
    meta: {
      title: '视频动态',
      hiddenCarousel: true,
    },
  },
  {
    path: '/notice/gxzz',
    name: 'notice-gxzz',
    component: () => import('@/views/notice/gxzz.vue'),
    meta: {
      title: '故乡杂志',
      hiddenCarousel: true,
    },
  },
  {
    path: '/notice/djzl',
    name: 'notice-djzl',
    component: () => import('@/views/notice/djzl.vue'),
    meta: {
      title: '党建专栏',
      hiddenCarousel: true,
    },
  },
  {
    path: '/notice/detail',
    name: 'notice-detail',
    component: () => import('@/views/notice/detail.vue'),
    meta: {
      title: '新闻详情',
      hiddenCarousel: true,
    },
  },
];

